import {gql} from '@apollo/client';
import {PICKUP_TASK_APPOINTMENT_FIELDS, PickupAppointmentType} from '../types/PickupTaskWithAppointmentsType';

export const GET_COMPLETED_TASK_BY_DRIVER = gql`
  query GetCompletedTaskByDriver($selectedDate: String) {
    getTaskByDriverAccountId(selectedDate: $selectedDate) {
      ...PickupTaskAppointmentFields
    }
  }
  ${PICKUP_TASK_APPOINTMENT_FIELDS}
`;

export interface GetCompletedTaskResponse {
  getTaskByDriverAccountId: PickupAppointmentType[][];
} 